import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core.module';
import { FormsModule } from '@angular/forms';
import { SecurityRestService } from './services/security/security-rest.service';
import { SecurityService } from './services/security/security.service';
import { LocaleRestService } from './services/locale/locale-rest.service';
import { ShowIfHasPermissionDirective } from './directives/security/show-if-has-permission.directive';
import { LocaleChangeService } from './services/locale/locale.change.service';
import { TranslateModule } from '@ngx-translate/core';
import { SelectOrganizationTypeComponent } from './components/select-organization-type/select-organization-type.component';
import { ExtendedInputComponent } from './components/extended-input/extended-input.component';
import { SelectCountryComponent } from './components/select-country/select-country.component';
import { CountryRestService } from './services/common/country-rest.service';
import { CountryDirectoryRestService } from './services/common/country-directory-rest.services';
import { DirectorySearchRestService } from './services/wsdirectory/directory-search-rest.service';
import { OrganizationRestService } from './services/oganization/organization-rest.service';
import { PersonRestService } from './services/person/person-rest.service';
import { SelectOrganizationSubtypeComponent } from './components/select-organization-subtype/select-organization-subtype.component';
import { FileRestService } from './services/common/file/file-rest.service';
import { FileUtilsService } from './services/common/file/file-utils.service';
import { SelectSuspensionStatusComponent } from './components/select-suspension-status/select-suspension-status.component';
import { LanguageRestService } from './services/common/language-rest.service';
import { TrackChangesRestService } from './services/track-changes/track-changes-rest.service';
import { SelectLanguageAcComponent } from './components/select-language-ac/select-language-ac.component';
import { SelectCurrencyAcComponent } from './components/select-currency-ac/select-currency-ac.component';
import { GlobalMessagesComponent } from './components/global-messages/global-messages.component';
import { GlobalMessagesService } from './services/messages/global.messages.service';
import { ContactRestService } from './services/contact/contact-rest.service';
import { UserRolesRestService } from './services/userrole/user-roles-rest.service';
import { ReportsRestService } from './services/reports/reports-rest.service';
import { SelectOrganizationComponent } from './components/select-organization/select-organization.component';
import { SelectOrganizationAcComponent } from './components/select-organization-ac/select-organization-ac.component';
import { SelectRegionComponent } from './components/select-region/select-region.component';
import { SelectRolesComponent } from './components/select-roles/select-roles.component';
import { SelectExpertiseAreasComponent } from './components/select-expertise-areas/select-expertise-areas.component';
import { FormHelperService } from './services/person/form-helper-service';
import { UserCountFormHelperService } from './services/reports/form-helper-service';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import { DateHttpInterceptor } from './interceptors/date-http-interceptor';
import { AddContactComponent } from './components/contacts/add-contact/add-contact.component';
import { AddContactService } from './services/contact/add-contact.service';
import { SelectContactTypeComponent } from './components/select-contact-type/select-contact-type.component';
import { SelectContactVisibilityComponent} from './components/select-contact-visibility/select-contact-visibility.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { SelectLanguagesAcComponent } from './components/select-languages-ac/select-languages-ac.component';
import { AddOrganizationAppointmentComponent } from './components/add-organization-appointment/add-organization-appointment.component';
import { SelectStandardTitleComponent } from './components/select-standard-title/select-standard-title.component';
import { AppointmentTitleRestService } from './services/appointment/appointment-title-rest.service';
import { AddAppointmentService } from './services/appointment/add-appointment.service';
import { SelectPersonAcComponent } from './components/select-person-ac/select-person-ac.component';
import { AddAppointmentPersonService } from './services/appointment/add-appointment-person.service';
import { ExpertiseAreaRestService } from './services/expertise-area/expertise-area-rest.service';
import { AddExpertiseAreaService } from './services/expertise-area/add-expertise-area.service';
import { AddStandardTitleService } from './services/appointment/add-standard-title.service';
import { AddCountryService } from './services/common/add-country.service';
import { SelectMembershipComponent } from './components/select-membership/select-membership.component';
import { ExportRestService } from './services/export/export-rest.service';
import { AddOrganizationTypeService } from './services/oganization/add-organization-type.service';
import { OrganizationTypeRestService } from './services/oganization/organization-type-rest.service';
import { LocationRestService } from './services/location/location-rest.service';
import { OrganizationSubtypeRestService } from './services/oganization/organization-subtype-rest.service';
import { AddOrganizationSubtypeService } from './services/oganization/add-organization-subtype.service';
import { RegionRestService } from './services/region/region-rest.service';
import { RegionDirectoryRestService } from './services/region/region-directory-rest.services';
import { NotificationRestService } from './services/notification/notification-rest.service';
import { AuthenticatedGuardService } from './services/security/authenticated-guard.service';
import { AddXsrfTokenHttpRequestInterceptor } from './interceptors/add-xsrf-token-http-request-interceptor';
import { AddressTypePipe } from './pipes/address-type-pipe/address-type-pipe';
import { ReplaceAtSignPipe } from './pipes/replace-at-sign-pipe/replace-at-sign-pipe';
import { OrganizationUpcomingEventsRestService } from './services/oganization/organization-upcoming-events-rest.service';
import { RoleGuardService } from './services/security/role-guard.service';
import { SelectEventCategoryComponent } from './components/select-event-category/select-event-category.component';
import { OrganizationEventCategoryService } from './services/oganization/organization-event-category.service';
import { SelectFeeCategoryComponent } from './components/select-fee-category/select-fee-category.component';
import { OrganizationFeeCategoryService } from './services/oganization/organization-fee-category.service';
import { AddOrganizationInteractionComponent } from './components/add-organization-interaction/add-organization-interaction.component';
import { AddInteractionService } from './services/interaction/add-interaction.service';
import { AddOrganizationPolicyDocumentService } from './services/oganization/add-organization-policy-document.service';
import { OrganizationPolicyDocumentsRestService } from './services/oganization/organization-policy-documents-rest.service';
import { AddFilesComponent } from './components/add-files/add-files.component';
import { ChangeDetectedOrganizationTypeService } from './services/oganization/change-organization-type.service';
import { FileInfoNamePipe } from './pipes/file-info-name-pipe/file-info-name-pipe';
import { ExtendedCardComponent } from './components/extended-card/extended-card.component';
import { OrganizationInformationRestService } from './services/nso-data-portal/rest-services/organization-information-rest.service';
import { OrganizationAddressComponent } from './components/organization-address/organization-address.component';
import { WsdRadialProgressComponent } from './components/nso-data-portal/wsd-radial-progress/wsd-radial-progress.component';
import { InteractionDialogComponent } from './components/data-portal/interaction-dialog/interaction-dialog.component';
import { ScoutDonateRestService } from './services/nso-data-portal/rest-services/scout-donate/rest/scout-donate-rest.service';
import { CensusRestService } from './services/nso-data-portal/rest-services/census-rest.service';
import { AddCensusService } from './services/nso-data-portal/add-services/add-census-service';
import { AddBeneficiaryService } from './services/nso-data-portal/add-services/add-beneficiary-service';
import { AddAgeRangesService } from './services/nso-data-portal/add-services/add-age-ranges-service';
import { AddCustomAgeRangesService } from './services/nso-data-portal/add-services/add-custom-age-ranges-service';
import { AdministrationInformationRestService } from './services/nso-data-portal/rest-services/administration-information-rest.service';
import { SelectAgeGroupTypeComponent } from './components/select-age-group-type/select-age-group-type.component';
import { BeneficiaryRestService } from './services/nso-data-portal/rest-services/beneficiary-rest.service';
import { AgeGroupTypePipe } from './pipes/age-group-type-pipe/age-group-type-pipe';
import { BeneficiaryTypePipe } from './pipes/beneficiary-type-pipe/beneficiary-type-pipe';
import { WsdUseUtcDirective } from './directives/date/utc-date.directive';
import { AgeGroupNamePipe } from './pipes/age-group-name-pipe/age-group-name-pipe';
import { PositiveNumbersOnlyDirective } from './directives/input/positive-numbers-only.directive';
import { ChartDataLabelsPlugin } from './chart-plugins/chart-data-labels-plugin';
import { ChartColorService } from './chart-plugins/chart-color-service';
import { NdpSearchService } from './services/nso-data-portal/rest-services/ndp-search.service';
import { RegionInformationRestService } from './services/nso-data-portal/rest-services/region-information-rest.service';
import { EntityInformationRestService } from './services/nso-data-portal/rest-services/entity-information-rest.service';
import { WorldInformationRestService } from './services/nso-data-portal/rest-services/world-information-rest.service';
import { ChartRestService } from './services/nso-data-portal/rest-services/chart-rest-service';
import { ExportRangeValuesDirective } from './directives/input/export-range-values.directive';
import { TrackChangeComponent } from '../track-changes/track-change/track-change.component';
import { TrackChangesComponent } from '../track-changes/track-changes.component';
import { InputMaskModule } from 'primeng/inputmask';
import { PanelModule } from 'primeng/panel';
import { RowDiffComponent } from '../track-changes/track-change/row-diff/row-diff.component';
import { ListDiffComponent } from '../track-changes/track-change/list-diff/list-diff.component';
import { OrganizationDirectoryRestService } from './services/oganization/organization-directory-rest.services';
import { UserRolesDirectoryRestService } from './services/userrole/user-roles-directory-rest.services';
import {NotFoundComponent} from "./components/not-found/not-found.component";
import {AddCustomWidgetComponent} from "./components/add-custom-widget/add-custom-widget-component";
import {AddCustomWidgetService} from "./services/custom-widgets/add-custom-widget.service";
import {ToggleButtonModule} from "primeng/togglebutton";


@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    TranslateModule,
    InputMaskModule,
    PanelModule,
    HttpClientModule,
    ToggleButtonModule
  ],
  exports: [
    ShowIfHasPermissionDirective,
    TranslateModule,
    SelectOrganizationTypeComponent,
    ExtendedInputComponent,
    SelectCountryComponent,
    SelectOrganizationComponent,
    SelectOrganizationSubtypeComponent,
    SelectSuspensionStatusComponent,
    SelectLanguageAcComponent,
    SelectLanguagesAcComponent,
    SelectCurrencyAcComponent,
    GlobalMessagesComponent,
    NotFoundComponent,
    SelectOrganizationAcComponent,
    SelectRegionComponent,
    SelectRolesComponent,
    SelectExpertiseAreasComponent,
    AddContactComponent,
    SelectContactTypeComponent,
    SelectContactVisibilityComponent,
    ContactsComponent,
    AddOrganizationAppointmentComponent,
    SelectPersonAcComponent,
    SelectStandardTitleComponent,
    SelectMembershipComponent,
    AddressTypePipe,
    ReplaceAtSignPipe,
    SelectEventCategoryComponent,
    SelectFeeCategoryComponent,
    AddOrganizationInteractionComponent,
    AddFilesComponent,
    FileInfoNamePipe,
    AgeGroupTypePipe,
    BeneficiaryTypePipe,
    ExtendedCardComponent,
    OrganizationAddressComponent,
    WsdRadialProgressComponent,
    InteractionDialogComponent,
    SelectAgeGroupTypeComponent,
    WsdUseUtcDirective,
    AgeGroupNamePipe,
    PositiveNumbersOnlyDirective,
    ExportRangeValuesDirective,
    AddCustomWidgetComponent
  ],
  declarations: [
    ShowIfHasPermissionDirective,
    SelectOrganizationTypeComponent,
    ExtendedInputComponent,
    SelectCountryComponent,
    SelectOrganizationComponent,
    SelectOrganizationSubtypeComponent,
    SelectSuspensionStatusComponent,
    SelectLanguageAcComponent,
    SelectLanguagesAcComponent,
    SelectCurrencyAcComponent,
    GlobalMessagesComponent,
    NotFoundComponent,
    SelectOrganizationAcComponent,
    SelectRegionComponent,
    SelectRolesComponent,
    SelectExpertiseAreasComponent,
    AddContactComponent,
    SelectContactTypeComponent,
    SelectContactVisibilityComponent,
    ContactsComponent,
    AddOrganizationAppointmentComponent,
    SelectStandardTitleComponent,
    SelectPersonAcComponent,
    SelectMembershipComponent,
    AddressTypePipe,
    ReplaceAtSignPipe,
    SelectEventCategoryComponent,
    SelectFeeCategoryComponent,
    AddOrganizationInteractionComponent,
    AddFilesComponent,
    FileInfoNamePipe,
    AgeGroupTypePipe,
    BeneficiaryTypePipe,
    ExtendedCardComponent,
    OrganizationAddressComponent,
    WsdRadialProgressComponent,
    InteractionDialogComponent,
    SelectAgeGroupTypeComponent,
    WsdUseUtcDirective,
    AgeGroupNamePipe,
    PositiveNumbersOnlyDirective,
    ExportRangeValuesDirective,
    TrackChangeComponent,
    TrackChangesComponent,
    RowDiffComponent,
    ListDiffComponent,
    AddCustomWidgetComponent
  ],
  providers: [
    ChartDataLabelsPlugin,
    ChartColorService,
    SecurityRestService,
    SecurityService,
    LocaleRestService,
    LocaleChangeService,
    CountryRestService,
    CountryDirectoryRestService,
    DirectorySearchRestService,
    OrganizationRestService,
    PersonRestService,
    FileRestService,
    FileUtilsService,
    LanguageRestService,
    GlobalMessagesService,
    ContactRestService,
    UserRolesRestService,
    ReportsRestService,
    FormHelperService,
    UserCountFormHelperService,
    AddContactService,
    AppointmentTitleRestService,
    AddAppointmentService,
    AddAppointmentPersonService,
    ExpertiseAreaRestService,
    AddExpertiseAreaService,
    AddStandardTitleService,
    AddCountryService,
    ExportRestService,
    AddOrganizationTypeService,
    AddOrganizationSubtypeService,
    OrganizationSubtypeRestService,
    OrganizationTypeRestService,
    OrganizationUpcomingEventsRestService,
    LocationRestService,
    RegionRestService,
    RegionDirectoryRestService,
    NotificationRestService,
    AuthenticatedGuardService,
    RoleGuardService,
    OrganizationEventCategoryService,
    OrganizationFeeCategoryService,
    AddInteractionService,
    ChangeDetectedOrganizationTypeService,
    AddOrganizationPolicyDocumentService,
    OrganizationPolicyDocumentsRestService,
    OrganizationInformationRestService,
    ScoutDonateRestService,
    CensusRestService,
    AddCensusService,
    AddAgeRangesService,
    BeneficiaryRestService,
    AddBeneficiaryService,
    AddCustomAgeRangesService,
    AdministrationInformationRestService,
    NdpSearchService,
    RegionInformationRestService,
    WorldInformationRestService,
    EntityInformationRestService,
    TrackChangesRestService,
    ChartRestService,
    OrganizationDirectoryRestService,
    UserRolesDirectoryRestService,
    AddCustomWidgetService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DateHttpInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddXsrfTokenHttpRequestInterceptor,
      multi: true
    }
  ]
})
export class SharedModule {
}
